import { render } from "./TrendsReportTable.vue?vue&type=template&id=2be9cef5&scoped=true"
import script from "./TrendsReportTable.vue?vue&type=script&lang=js"
export * from "./TrendsReportTable.vue?vue&type=script&lang=js"

import "./TrendsReportTable.vue?vue&type=style&index=0&id=2be9cef5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be9cef5"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QTd,QBtn,QIcon});
